var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "MainView box_size" },
    [
      _c("Header", { staticClass: "atrilHeader" }),
      _vm.view === "Home"
        ? _c("Home")
        : _vm.view === "Agendar"
        ? _c("Agendar")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }